// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-form[data-v-73283826]{display:grid;grid-template-areas:\"header\" \"location\" \"code\"}.location-form__header[data-v-73283826]{grid-area:header}.location-form__location[data-v-73283826]{grid-area:location}.location-form__code[data-v-73283826]{grid-area:code}", ""]);
// Exports
module.exports = exports;
